export const DEMO_ACCOUNT_DAHSBOARD_ONBOARDING_ID = '8be9341a-86eb-4b28-9638-536b717d1486';

export const HIGHLIGHTS_ONBOARDING_ID = '07d8b460-e62d-428c-9ea4-1574cc042586';
